<script>
import DataTable from 'datatables.net-vue3';

export default {
    props: {
        ListData :{
            type : Object,
        },
        dtKey:{
            type : Number,
        }
    },

    data() {
        return {
            totalEstimate:'',
        }},
    methods: {
      
    },
    mounted() {
        // this.$refs.dataTable.api().clear().rows.add(this.ListData).draw();
    },

    components: {
    DataTable,
  },
}

</script>

<template>
    <DataTable :options="{lengthChange: false,searching: false}" :key="dtKey" :ref="dtKey" class="table table-striped table-nowrap mb-0" :id="dtKey"> 
        <thead class="table-secondary">
            <tr>
                <!-- 1 -->
                <th>#.</th>
                <th scope="col">straight_through</th>
                <th scope="col">order Id</th>
                <th scope="col">Order Create</th>
                <th scope="col">Name As Per Nric</th>
                <!-- 2 -->
                <th scope="col">Phone Number</th>
                <th scope="col">Pragram Name</th>
                <th scope="col">Program Fee</th>
                <th scope="col">Product Name</th>
                <th scope="col">Monthly Sub</th>
                <!-- 3 -->
                <th scope="col">Price</th>
                <th scope="col">Status Order</th>
                <th scope="col">Credit Check Result</th>
                <th scope="col">Cancel Reason</th>
                <th scope="col">Nric</th>
                <!-- 4 -->
                <th scope="col">Branch</th>
                <th scope="col">State</th>
                <th scope="col">Capacity Product</th>
                <th scope="col">Category Device</th>
                <th scope="col">DOB</th>
                <!-- 5 -->
                <th scope="col">Age</th>
                <th scope="col">Gender</th>
                <th scope="col">Device Cost</th>
                <th scope="col">Applicationsource</th>
            </tr>
        </thead>
        <tbody>                        
            <tr v-for="(item, index) in ListData" :key="index" class="content">
                <!-- 1 -->
                <td>{{ index+1 }}</td>
                <td>{{ item.straight_through }}</td>
                <td>{{ item.orderId }}</td>
                <td>{{ item.created_at }}</td>
                <td>{{ item.name_as_per_nric }}</td>
                <!-- 2 -->
                <td>{{ item.phone_number }}</td>
                <td>{{ item.program_name }}</td>
                <td>{{ item.program_fee }}</td>
                <td>{{ item.product_name }}</td>
                <td>{{ item.monthly_subscription }}</td>
                <!-- 3 -->
                <td>{{ item.price }}</td>
                <td>{{ item.order_status_name }}</td>
                <td>{{ item.credit_check_result }}</td>
                <td>{{ item.cancel_reason }}</td>
                <td>{{ item.nric }}</td>
                <!-- 4 -->
                <td>{{ item.branchname }}</td>
                <td>{{ item.state }}</td>
                <td>{{ item.capactyname }}</td>
                <td>{{ item.categoryname }}</td>
                <td>{{ item.dob }}</td>
                <!-- 5 -->
                <td>{{ item.age }}</td>
                <td>{{ item.gender }}</td>
                <td>{{ item.device_cost }}</td>
                <td>{{ item.applicationsource }}</td>                                         
            </tr>
        </tbody>
    </DataTable>
</template>